import type {
    PageArticleFieldsFragment,
    TeamFieldsFragment,
} from "@/lib/contentful/__generated/graphql.types";
import type { ReactNode } from "react";
import {
    AspectRatio,
    Box,
    CldImage,
    CldVideo,
    CldVideoPlayerProvider,
    Flex,
    hasCloudinaryAsset,
    isCloudinaryVideo,
} from "@project/ui";
import { TemporaryPlayPauseButton } from "@/components/temporary-play-pause-button";
import { AnimatingWrapper } from "@/components/animating-wrapper";

type ModuleTypes = TeamFieldsFragment | PageArticleFieldsFragment;

type HeroFullScreenProps = ModuleTypes & {
    fullScreenHeaderComponent?: ReactNode;
};

export const HeroFullScreen = (props: HeroFullScreenProps) => {
    const { fullScreenHeaderComponent } = props;

    const isTeamPage = props.__typename === "Team";
    const asset = isTeamPage ? props.asset : props.heroAsset;

    return (
        <CldVideoPlayerProvider autoplay muted loop>
            <Flex
                h={"auto"}
                w="full"
                overflow="hidden"
                flexDirection="column"
                justifyContent={{ base: "flex-start", md: "space-between" }}
                pt={{ base: "navHeightMobile", s: "navHeightDesktop" }}
            >
                {fullScreenHeaderComponent}

                {hasCloudinaryAsset(asset) && (
                    <AnimatingWrapper delay={1}>
                        <Box as="figure" position="relative">
                            <AspectRatio ratio={["1:1", "2:1"]}>
                                {isCloudinaryVideo(asset) ? (
                                    <CldVideo
                                        cloudinaryAsset={asset}
                                        wrapperProps={{
                                            position: "absolute",
                                            borderRadius: "unset",
                                        }}
                                        loop
                                    />
                                ) : (
                                    <CldImage
                                        cloudinaryAsset={asset}
                                        priority={true}
                                        fill
                                        wrapperProps={{ borderRadius: "unset" }}
                                    />
                                )}
                            </AspectRatio>
                            {hasCloudinaryAsset(asset) && isCloudinaryVideo(asset) && (
                                <TemporaryPlayPauseButton />
                            )}
                        </Box>
                    </AnimatingWrapper>
                )}
            </Flex>
        </CldVideoPlayerProvider>
    );
};
